import OrderService from '@/service/orderService'
import { checkWeiPay, reqPrePayConfig } from '@/service/weiPayService'
import type { Order } from '@/types/info'
import authClient from '@/utils/auth'
import apiClient, { setShadowWorked} from '@/utils/http'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Button, Input, Picker, Space, Toast } from 'antd-mobile'
import { useCallback, useEffect, useState } from 'react'

export const Route = createFileRoute('/test/')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const [visible, setVisible] = useState(false)
  const [orderList, setOrderList] = useState<Order[]>([])
  const [selectedOrder, setSelectedOrder] = useState<Order>()
  const [isLoading, setIsLoading] = useState(true)
  const [classIdStr, setClassIdStr] = useState<string>('')
  const getOrderList = useCallback(async () => {
    const orderList = await OrderService.reqOrderList()
    setOrderList(orderList)
    const id = selectedOrder?.id
    if (!orderList.find((order) => order.id === id)) {
      setSelectedOrder(undefined)
      return
    }
    setSelectedOrder(orderList.find((order) => order.id === id))
  }, [selectedOrder])
  useEffect(() => {
    const reset = setShadowWorked()
    getOrderList().then(() => {
      setIsLoading(false)
    })
    return () => {
      reset()
    }
  }, [])
  const id = selectedOrder?.id
  return (
    <>
      <Space direction="vertical" align="center" style={{ width: '100vw' }}>
        <Picker
          loading={isLoading}
          columns={[
            orderList.map((order) => ({
              label: order.id + ' ' + order.order_status,
              value: order.id,
              key: order.id,
            })),
          ]}
          visible={visible}
          onClose={() => setVisible(false)}
          onConfirm={(values) => {
            setSelectedOrder(orderList.find((order) => order.id === values[0])!)
          }}
        ></Picker>
        <p>
          当前订单：{selectedOrder?.id} {selectedOrder?.order_status}{' '}
        </p>
        <Button
          color={!selectedOrder ? 'primary' : 'default'}
          onClick={() => setVisible(true)}
        >
          选择订单
        </Button>
        <Button
          color={
            selectedOrder?.order_status === 'PENDING_PAYMENT'
              ? 'primary'
              : 'default'
          }
          onClick={async () => {
            if (!id) {
              return
            }
            await reqPrePayConfig(id)
            await checkWeiPay(id)
            await getOrderList()
          }}
        >
          支付费用
        </Button>
        <Button
          color={
            selectedOrder?.order_status === 'PENDING_ACCOMMODATION'
              ? 'primary'
              : 'default'
          }
          onClick={() => {
            if (!id) {
              return
            }
            navigate({ to: `/order/${id}` })
          }}
        >
          跳转至订单详情
        </Button>
        <Button
          color={selectedOrder ? 'danger' : 'default'}
          onClick={async () => {
            if (!id) {
              return
            }
            await authClient.delete('/order/' + id, {
              headers: {
                Authorization:
                  'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ7XCJ1c2VySWRcIjpcIjFcIn0iLCJleHAiOjE4NTE5NzA1MzR9.bWNSjWZ_fUSVKc3R7LjUdXl29-PrwJ-nGo9Uaj-rDHo',
              },
            })
            await getOrderList()
          }}
        >
          删除订单
        </Button>
        <Input
          placeholder="请输入草稿classId"
          value={classIdStr}
          onChange={(value) => setClassIdStr(value)}
        />
        <Button
          color={Number(classIdStr) ? 'danger' : 'default'}
          onClick={async () => {
            if (!Number(classIdStr)) {
              return
            }
            await apiClient.delete(`/form-draft/key/${classIdStr}`)
            Toast.show('删除成功')
          }}
        >
          删除草稿
        </Button>
        <Button onClick={() => navigate({ to: '/test/manual-login' })}>登陆页面</Button>
      </Space>
    </>
  )
}
